import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ArticleContentCardFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, bookmark?: { id: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null } | null };


export type ArticleContentCardFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ArticleContentCardWithUserPerformanceFragment = { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, status: Types.ResourceStatusEnum, cover?: { name: string, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum } | null, bookmark?: { id: string } | null, performance?: { id: string, status: Types.PerformanceStatusEnum, estimatedTimeSpent?: number | null, enrolmentInfo?: { dueDate?: string | null } | null } | null };


export type ArticleContentCardWithUserPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ArticleContentCardFragmentDoc = /*#__PURE__*/ gql`
    fragment ArticleContentCard on ArticleContentType {
  id
  name
  type
  duration
  description
  status
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  bookmark {
    id
  }
  performance {
    id
    status
    progress
    estimatedTimeSpent
  }
}
    `;
export const ArticleContentCardWithUserPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ArticleContentCardWithUserPerformance on ArticleContentType {
  id
  name
  type
  duration
  description
  status
  cover {
    name
    url
    size
    mimeType
    mediaId
    kind
  }
  bookmark {
    id
  }
  performance(userId: $userId) {
    id
    status
    estimatedTimeSpent
    enrolmentInfo {
      dueDate
    }
  }
}
    `;